import React from 'react';
import { ActivityIndicator, } from 'react-native';
import { Button, withTheme } from '@rneui/themed';
import { FileType, PlaybackState, usePlaybackStateStore, useContentPlaybackState, } from '@annunciate/core';
import { PlaybackEventEmitter, PlaybackEvent } from '@annunciate/core';
import { FAIcon } from '../elements';
export const UnthemedPlayButton = ({ containerStyle = {}, iconStyle = {}, iconSize, playIconName, pauseIconName, customIcon, content, isLeftAligned, isRightAligned, }) => {
    const playing = usePlaybackStateStore(state => state.content);
    const setState = usePlaybackStateStore(state => state.setState);
    const requestedContent = content || playing;
    const { state } = useContentPlaybackState(requestedContent?.id);
    const isLoading = state === PlaybackState.LOADING;
    const isPlaying = state === PlaybackState.PLAYING;
    const fileType = requestedContent?.asset?.type;
    let playIcon = fileType === FileType.EBOOK ? 'book' : 'play';
    let pauseIcon = fileType === FileType.EBOOK ? 'book' : 'pause';
    if (playIconName) {
        playIcon = playIconName;
    }
    if (pauseIconName) {
        pauseIcon = pauseIconName;
    }
    if (!requestedContent?.asset) {
        return null;
    }
    const Icon = customIcon ? (React.createElement(React.Fragment, null, customIcon)) : (React.createElement(FAIcon, { name: isPlaying ? pauseIcon : playIcon, size: iconSize, style: iconStyle }));
    return (React.createElement(Button, { type: "clear", containerStyle: containerStyle, isLeftAligned: isLeftAligned, isRightAligned: isRightAligned, onPress: () => {
            if (isLoading)
                return;
            if (isPlaying) {
                PlaybackEventEmitter.emit(PlaybackEvent.PAUSE, { content: requestedContent });
            }
            else {
                if (fileType === FileType.AUDIO || fileType === FileType.VIDEO) {
                    setState(requestedContent.id, PlaybackState.LOADING);
                }
                PlaybackEventEmitter.emit(PlaybackEvent.START, { content: requestedContent });
            }
        } }, !isLoading ? (Icon) : (React.createElement(ActivityIndicator, { size: iconSize }))));
};
export const PlayButton = withTheme(UnthemedPlayButton, 'PlayButton');
//# sourceMappingURL=PlayButton.js.map